(function () {
  'use strict';

  var loader = document.currentScript;
  if (!loader || window.__lbxAdvisorLoaderBound) return;
  window.__lbxAdvisorLoaderBound = true;

  var cssSource = loader.getAttribute('data-lbx-advisor-css-src');
  var jsSource = loader.getAttribute('data-lbx-advisor-js-src');
  var state = 'idle';
  var queue = [];

  function flushQueue() {
    state = 'ready';
    queue.splice(0).forEach(function (button) {
      if (!document.documentElement.contains(button)) return;
      button.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    });
  }

  function loadAdvisor() {
    if (state === 'ready') return Promise.resolve();
    if (state === 'loading') return window.__lbxAdvisorPromise;

    state = 'loading';
    window.__lbxAdvisorPromise = new Promise(function (resolve, reject) {
      var pending = 0;
      var failed = false;

      function done() {
        pending -= 1;
        if (!failed && pending <= 0) {
          flushQueue();
          resolve();
        }
      }

      function fail() {
        if (failed) return;
        failed = true;
        state = 'idle';
        reject(new Error('Could not load the advisor'));
      }

      if (cssSource && !document.querySelector('link[data-lbx-advisor-style]')) {
        pending += 1;
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = cssSource;
        link.setAttribute('data-lbx-advisor-style', '');
        link.onload = done;
        link.onerror = fail;
        document.head.appendChild(link);
      }

      if (jsSource && !document.querySelector('script[data-lbx-advisor-script]')) {
        pending += 1;
        var script = document.createElement('script');
        script.src = jsSource;
        script.async = false;
        script.setAttribute('data-lbx-advisor-script', '');
        script.onload = done;
        script.onerror = fail;
        document.head.appendChild(script);
      }

      if (pending === 0) {
        flushQueue();
        resolve();
      }
    });

    return window.__lbxAdvisorPromise;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-lbx-quiz-open]');
    if (!button || state === 'ready') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    queue.push(button);
    loadAdvisor().catch(function () {
      queue = [];
    });
  }, true);
})();
